import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <p>However, awareness of bias such as groupthink can lead to
                                                effective strategies to combat bias, and these strategies
                                                were put into motion in the wake of the Challenger disaster
                                                to good effect.</p>
                                            <p>For more information on preventing groupthink, there are
                                                relevant sections in the tool ‘How to challenge others
                                                effectively’.</p>
                                            <p><span className="subtiltereg">Developing your decision making skills will help you and your team make sure the decisions you make are balanced, in terms of risk and benefit.</span>
                                            </p>
                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">BIASES IN DECISION MAKING</span>
                                            </div>
                                            <p>Bias means ‘tendency’ or ‘preference.’ We can be aware of our
                                                own biases, or not – they can be subconscious. This means
                                                our decision making can be influenced by factors which may
                                                have no bearing on the matter we’re dealing with.</p>
                                            <p>Here are some examples of biases many of us hold, knowingly
                                                or unknowingly:</p>
                                            <table width="100%" cellSpacing="0" cellPadding="0" border="0"
                                                   className="ilead_v_sport paraspace">
                                                <tbody>
                                                <tr>
                                                    <th width="30%" valign="top" align="left"
                                                        className="green_curve">Bias
                                                    </th>
                                                    <th width="70%" valign="top" align="left"
                                                        className="green_curve1">Definition
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="30%" valign="top" align="left"
                                                        className="darkgreen"><p><span
                                                        className="subtiltereg">Selective bias</span></p>
                                                    </td>
                                                    <td width="70%" valign="top" align="left"
                                                        className="darkgreen"><p>This is a tendency to focus
                                                        or gather facts which support what we anticipate, or
                                                        hope for. We therefore disregard other facts which
                                                        may support alternative conclusions.</p></td>
                                                </tr>
                                                <tr>
                                                    <td width="30%" valign="top" align="left"
                                                        className="lightgreen"><p><span
                                                        className="subtiltereg">Discontinuation of evidence searching</span>
                                                    </p></td>
                                                    <td width="70%" valign="top" align="left"
                                                        className="lightgreen"><p>A tendency to accept the
                                                        first alternative that looks as if it might work –
                                                        rather than checking that others might not be as
                                                        good or better.</p></td>
                                                </tr>
                                                <tr>
                                                    <td width="30%" valign="top" align="left"
                                                        className="darkgreen"><p><span
                                                        className="subtiltereg">Unwillingness to change</span>
                                                    </p></td>
                                                    <td width="70%" valign="top" align="left"
                                                        className="darkgreen"><p>We may develop patterns of
                                                        behaviour according to our experiences, and continue
                                                        them even in different or unrelated circumstances.
                                                        In this way, we’d do something a certain way without
                                                        considering whether it’s the best option.</p></td>
                                                </tr>
                                                <tr>
                                                    <td width="30%" valign="top" align="left"
                                                        className="lightgreen"><p><span
                                                        className="subtiltereg">Rebelliousness</span></p>
                                                    </td>
                                                    <td width="70%" valign="top" align="left"
                                                        className="lightgreen"><p>A tendency to do other
                                                        than what is wanted, expected or demanded by others
                                                        – especially those perceived to be in a position of
                                                        authority.</p></td>
                                                </tr>
                                                <tr>
                                                    <td width="30%" valign="top" align="left"
                                                        className="darkgreen"><p><span
                                                        className="subtiltereg">Experienced-based limitations</span>
                                                    </p></td>
                                                    <td width="70%" valign="top" align="left"
                                                        className="darkgreen"><p>An unwillingness or
                                                        inability to look beyond our own experiences. This
                                                        can result as much from fear of trying something
                                                        new, as from arrogance.</p></td>
                                                </tr>
                                                <tr>
                                                    <td width="30%" valign="top" align="left"
                                                        className="lightgreen"><p><span
                                                        className="subtiltereg">Selective perception</span>
                                                    </p></td>
                                                    <td width="70%" valign="top" align="left"
                                                        className="lightgreen"><p>Actively filtering
                                                        information we personally consider irrelevant or
                                                        insignificant to a particular decision.</p></td>
                                                </tr>
                                                <tr>
                                                    <td width="30%" valign="top" align="left"
                                                        className="darkgreen"><p><span
                                                        className="subtiltereg">Optimism</span></p></td>
                                                    <td width="70%" valign="top" align="left"
                                                        className="darkgreen"><p>Deliberately disregarding
                                                        potential problems, which distorts our thinking as
                                                        much as pessimism!</p></td>
                                                </tr>
                                                <tr>
                                                    <td width="30%" valign="top" align="left"
                                                        className="lightgreen"><p><span
                                                        className="subtiltereg">Choice/supportive bias</span>
                                                    </p></td>
                                                    <td width="70%" valign="top" align="left"
                                                        className="lightgreen"><p>We ‘re-script’ our memory
                                                        of available options and the reasons for our
                                                        decision, to reassure ourselves (and others) that
                                                        it’s ‘better’ or more desirable than it may
                                                        originally have seemed!</p></td>
                                                </tr>
                                                <tr>
                                                    <td width="30%" valign="top" align="left"
                                                        className="darkgreen"><p><span
                                                        className="subtiltereg">Recency effect</span></p>
                                                    </td>
                                                    <td width="70%" valign="top" align="left"
                                                        className="darkgreen"><p>Attention is given to new
                                                        or recent facts and data rather than existing or
                                                        previous information, which can be ignored or
                                                        forgotten.</p></td>
                                                </tr>
                                                <tr>
                                                    <td width="30%" valign="top" align="left"
                                                        className="lightgreen"><p><span
                                                        className="subtiltereg">Primacy effect</span></p>
                                                    </td>
                                                    <td width="70%" valign="top" align="left"
                                                        className="lightgreen"><p>This is the opposite of
                                                        the ‘Recency effect’ – original information is
                                                        adhered to and new facts or data ignored.</p></td>
                                                </tr>
                                                <tr>
                                                    <td width="30%" valign="top" align="left"
                                                        className="darkgreen"><p><span
                                                        className="subtiltereg">Repetition bias</span></p>
                                                    </td>
                                                    <td width="70%" valign="top" align="left"
                                                        className="darkgreen"><p>A tendency to unquestioning
                                                        belief in what we’re told, or in what we’re told by
                                                        most of those around us.</p></td>
                                                </tr>
                                                <tr>
                                                    <td width="30%" valign="top" align="left"
                                                        className="lightgreen"><p><span
                                                        className="subtiltereg">Anchoring or adjustment</span>
                                                    </p></td>
                                                    <td width="70%" valign="top" align="left"
                                                        className="lightgreen"><p>Decisions based on
                                                        previous information subsequently influence our
                                                        approach to new or fresh information.</p></td>
                                                </tr>
                                                <tr>
                                                    <td width="30%" valign="top" align="left"
                                                        className="darkgreen"><p><span
                                                        className="subtiltereg">Peer pressure or groupthink</span>
                                                    </p></td>
                                                    <td width="70%" valign="top" align="left"
                                                        className="darkgreen"><p>Conforming to the opinions
                                                        of our peers, or people important to us at a
                                                        particular time.</p></td>
                                                </tr>
                                                </tbody>
                                            </table>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}